import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PageNotFound from "../common/PageNotFound";
import CandidateFeedback from "../component/candidateFeedback/candidateFeedback";
import Designation from "../component/configuration/Designation/Designation";
import AddCredentials from "../component/configuration/ManageCredentials/addCredentials";
import MeetingCredentials from "../component/configuration/MeetingCredentials/meetingCredentials";
import Project from "../component/configuration/Project/Project";
import Skill from "../component/configuration/Skill/Skill";
import RoleList from "../component/Roles/RoleList";
import StatusPage from "../component/StatusPage/StatusPage";
import { RecordingProvider } from "../component/chat-bot/RecordingContext";
import CandidateDetails from "../component/viewRequestDetail/Tabs/CandidateDetailsTab/candidateDetails";
import ProtectedRoutes from "./protectedRoutes";

const AddCandidate = React.lazy(
  () => import("../component/manageCandidate/addCandidate")
);
// const PlanLandingPage = React.lazy(
//   () => import("../component/planLandingPage/planLandingPage")
// );
const ScheduleCandidate = React.lazy(
  () =>
    import(
      "../component/viewRequestDetail/Tabs/ScheduleCandidateTab/ScheduleCandidate"
    )
);

const ManageSources = React.lazy(
  () => import("../component/configuration/ManageSources/ManageSources")
);
const ManageLeadTime = React.lazy(
  () => import("../component/configuration/mangeLeadTime")
);
const ConfigureRole = React.lazy(
  () => import("../component/configuration/ConfigureRoles/ConfigureRole")
);
const Education = React.lazy(
  () => import("../component/configuration/ManageEducation/Education")
);
const Reports = React.lazy(() => import("../component/reports/report"));
const InterviewerPanelSetup = React.lazy(
  () =>
    import("../component/configuration/InterviewPanel/InterviewerPanelSetup")
);
const InterviewList = React.lazy(
  () => import("../component/configuration/InterviewList")
);
const Layout = React.lazy(() => import("../component/layout/layout"));
const Login = React.lazy(() => import("../component/login/login"));
const Dashboard = React.lazy(() => import("../component/dashboard/dashboard"));

const ManageCandidate = React.lazy(
  () => import("../component/manageCandidate/manageCandidate")
);
const ManageRequest = React.lazy(
  () => import("../component/manageRequest/manageRequest")
);
const AddRequest = React.lazy(
  () => import("../component/manageRequest/addRequest")
);
const ViewRequest = React.lazy(
  () => import("../component/manageRequest/viewRequest")
);
const AddJDTemplate = React.lazy(
  () => import("../component/configuration/addJDTemplate")
);
const JdTemplateList = React.lazy(
  () => import("../component/configuration/jdTemplateList")
);
const TechnologyList = React.lazy(
  () => import("../component/configuration/TechnologyList/TechnologyList")
);
const InterviewSheetFeedbackEdit = React.lazy(
  () => import("../component/InterviewSheet/interviewSheetFeedbackEdit")
);
const InterviewSheetFeedbackView = React.lazy(
  () => import("../component/InterviewSheet/interviewSheetFeedbackView")
);
const ViewRequirementDetails = React.lazy(
  () => import("../component/viewRequestDetail/viewRequestDetail")
);
const candidateHistory = React.lazy(
  () => import("../component/manageCandidate/candidateHistory/candidateHistory")
);
const CallingCandidateDetail = React.lazy(
  () =>
    import(
      "../component/manageCandidate/callingCandidateDetail/callingCandidateDetail"
    )
);
const AddCallingCandidateDetails = React.lazy(
  () =>
    import(
      "../component/manageCandidate/callingCandidateDetail/addCallingCandidateDetails"
    )
);
const ViewCallingCandidateDetail = React.lazy(
  () =>
    import(
      "../component/manageCandidate/callingCandidateDetail/ViewCallingCandidateDetail"
    )
);
const SignUp = React.lazy(() => import("../component/signup/Signup"));
const ManageUser = React.lazy(
  () => import("../component/manageUser/manageUser")
);
const ResumeScreening = React.lazy(
  () => import("../component/resumeScreening/resumeScreening")
);
const ResumeDashboard = React.lazy(
  () => import("../component/resumeScreening/ResumeDashboard")
);
const AddUser = React.lazy(() => import("../component/manageUser/addUser"));
const SetPassword = React.lazy(() => import("../component/login/setPassword"));
const ChatBot = React.lazy(() => import("../component/chat-bot/chatBot"));
const ChatBotHistory = React.lazy(
  () => import("../component/chat-bot/chatBotHistory")
);

const EmailConfiguration = React.lazy(
  () =>
    import("../component/configuration/EmailConfigurations/EmailConfiguration")
);
const EmailConfigurationList = React.lazy(
  () =>
    import(
      "../component/configuration/EmailConfigurations/EmailConfigurationList"
    )
);

const LetterConfiguration = React.lazy(
  () =>
    import(
      "../component/configuration/LetterConfigurations/LetterConfiguration"
    )
);
const LetterConfigurationList = React.lazy(
  () =>
    import(
      "../component/configuration/LetterConfigurations/LetterConfigurationList"
    )
);
const GenerateOfferLetter = React.lazy(()=> import('../component/configuration/LetterConfigurations/GenerateOfferLetter'))

const CronConfiguration = React.lazy(
  () => import("../component/configuration/CronConfiguration/CronConfiguration")
);
const RenewalPage = React.lazy(
  () => import("../component/RenewalPage/RenewalPage")
);
const Subscription = React.lazy(
  () => import("../component/Subscription/Subscription")
);
export const RoutesPage = () => {
  let token = localStorage.getItem("accessToken");

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {/* Public Routes */}
          {/* <Route
            path="/pricing"
            element={token ? <Navigate to="/dashboard" /> : <PlanLandingPage />}
          /> */}
          <Route
            path="/login"
            element={token ? <Navigate to="/dashboard" /> : <Login />}
          />
          <Route
            path="/signup/:planId"
            element={token ? <Navigate to="/dashboard" /> : <SignUp />}
          />

          <Route
            path="/set-password"
            element={token ? <Navigate to="/dashboard" /> : <SetPassword />}
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />

          {/* Protected Routes */}
          <Route
            path="/callingCandidate"
            element={<ProtectedRoutes Component={CallingCandidateDetail} />}
          />
          <Route
            path="callingCandidate/addCallingCandidate"
            element={<ProtectedRoutes Component={AddCallingCandidateDetails} />}
          />
          <Route
            path="callingCandidate/editCallingCandidate/:callingCandidateId"
            element={<ProtectedRoutes Component={AddCallingCandidateDetails} />}
          />
          <Route
            path="callingCandidate/viewCallingCandidate/:callingCandidateId"
            element={<ProtectedRoutes Component={ViewCallingCandidateDetail} />}
          />
          <Route
            path="/manageSources"
            element={<ProtectedRoutes Component={ManageSources} />}
          />
          <Route
            path="/roleActivity"
            element={<ProtectedRoutes Component={ConfigureRole} />}
          />
          <Route
            path="/manageSkill"
            element={<ProtectedRoutes Component={Skill} />}
          />
          <Route
            path="/manageProject"
            element={<ProtectedRoutes Component={Project} />}
          />
          <Route
            path="/manageDesignation"
            element={<ProtectedRoutes Component={Designation} />}
          />
          <Route
            path="/manageRole"
            element={<ProtectedRoutes Component={RoleList} />}
          />
          <Route
            path="/platformIntegrations"
            element={<ProtectedRoutes Component={MeetingCredentials} />}
          />
          <Route
            path="/authConfiguration"
            element={<ProtectedRoutes Component={AddCredentials} />}
          />
          <Route
            path="/manageEducation"
            element={<ProtectedRoutes Component={Education} />}
          />
          <Route
            path="/interviewList/viewCandidateDetails/:candidateId"
            element={<ProtectedRoutes Component={<CandidateDetails />} />}
          />
          <Route
            path="/manageCandidate/viewCandidateDetails/:candidateId"
            element={<ProtectedRoutes Component={ViewRequirementDetails} />}
          />
          <Route
            path="/manageCandidate/candidateHistory/:candidateId"
            element={<ProtectedRoutes Component={candidateHistory} />}
          />
          <Route
            path="/myInterview/interviewSheetFeedbackView/:candidateId/:RequirementId"
            element={<ProtectedRoutes Component={InterviewSheetFeedbackView} />}
          />
          <Route
            path="/myInterview/interviewSheetFeedback/:scheduleId/:requirementId"
            element={<ProtectedRoutes Component={InterviewSheetFeedbackEdit} />}
          />
          <Route
            path="/dashboard"
            element={<ProtectedRoutes Component={Dashboard} />}
          />
          <Route
            path="/myInterview"
            element={<ProtectedRoutes Component={InterviewList} />}
          />
          <Route
            path="/manageRequest"
            element={<ProtectedRoutes Component={ManageRequest} />}
          />
          <Route
            path="/manageRequest/editRequest/:id"
            element={<ProtectedRoutes Component={AddRequest} />}
          />
          <Route
            path="/manageRequest/addRequest"
            element={<ProtectedRoutes Component={AddRequest} />}
          />
          <Route
            path="/manageRequest/viewRequest/:id"
            element={<ProtectedRoutes Component={ViewRequest} />}
          />
          <Route
            path="/manageCandidate"
            element={<ProtectedRoutes Component={ManageCandidate} />}
          />
          <Route
            path="/manageCandidate/addCandidate"
            element={<ProtectedRoutes Component={AddCandidate} />}
          />
          <Route path="/candidateProfile" element={<AddCandidate />} />
          <Route path="/candidateFeedback" element={<CandidateFeedback />} />
          <Route
            path="manageCandidate/editCandidateDetails/:id"
            element={<ProtectedRoutes Component={AddCandidate} />}
          />
          <Route
            path="/manageCandidate/scheduleInterview"
            element={<ProtectedRoutes Component={ScheduleCandidate} />}
          />
          <Route
            path="/manageCandidate/scheduleInterview/:candidateId"
            element={<ProtectedRoutes Component={ScheduleCandidate} />}
          />
          <Route
            path="/manageUser"
            element={<ProtectedRoutes Component={ManageUser} />}
          />
          <Route path="/SmartResumeParser" element={<ResumeScreening />} />
          <Route path="/resumeDashboard" element={<ResumeDashboard />} />
          <Route path="/manageUser/addUser" element={<AddUser />} />
          <Route path="/manageUser/importUsers" element={<AddUser />} />
          <Route
            path="/manageUser/editUser/:userId"
            element={<ProtectedRoutes Component={AddUser} />}
          />
          <Route
            path="/jdTemplate"
            element={<ProtectedRoutes Component={JdTemplateList} />}
          />
          <Route
            path="/manageTechnology"
            element={<ProtectedRoutes Component={TechnologyList} />}
          />
          <Route
            path="/jdTemplate/editJdTemplate/:templateId"
            element={<ProtectedRoutes Component={AddJDTemplate} />}
          />
          <Route
            path="/jdTemplate/addJdTemplate"
            element={<ProtectedRoutes Component={AddJDTemplate} />}
          />
          <Route
            path="/manageLeadTime"
            element={<ProtectedRoutes Component={ManageLeadTime} />}
          />
          <Route
            path="/interviewPanel"
            element={<ProtectedRoutes Component={InterviewerPanelSetup} />}
          />
          <Route
            path="/reports"
            element={<ProtectedRoutes Component={Reports} />}
          />
          <Route
            path="/chat-bot"
            element={
              <RecordingProvider>
                <ChatBot />{" "}
              </RecordingProvider>
            }
          />
          <Route
            path="/myInterview/candidatechatHistory/:scheduleId/:candidateId"
            element={<ChatBotHistory />}
          />
          <Route
            path="/renewalPage"
            element={<ProtectedRoutes Component={RenewalPage} />}
          />
          <Route path="/changePlan" element={<RenewalPage />} />
          <Route
            path="/emailConfiguration"
            element={<ProtectedRoutes Component={EmailConfigurationList} />}
          />
          <Route
            path="/emailConfiguration/editEmailConfiguration/:eventId"
            element={<ProtectedRoutes Component={EmailConfiguration} />}
          />
          <Route
            path="/letterConfiguration"
            element={<ProtectedRoutes Component={LetterConfigurationList} />}
          />
          <Route
            path="/letterConfiguration/addLetterConfiguration"
            element={<ProtectedRoutes Component={LetterConfiguration} />}
          />
          <Route
            path="/letterConfiguration/editLetterConfiguration/:eventId"
            element={<ProtectedRoutes Component={LetterConfiguration} />}
          />
          <Route
            path="/letterConfiguration/viewLetterConfiguration/:eventId"
            element={<ProtectedRoutes Component={LetterConfiguration} />}
          />
          <Route
            path="/manageCandidate/viewCandidateDetails/generateOfferLetter"
            element={<ProtectedRoutes Component={GenerateOfferLetter} />}
          />
          <Route path="/success" element={<StatusPage />} />
          <Route path="/fail" element={<StatusPage />} />
          <Route
            path="/cronConfiguration"
            element={<ProtectedRoutes Component={CronConfiguration} />}
          />
          <Route path="/subscriptions" element={<Subscription />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};
export default { RoutesPage };
